<template>
  <h1>Trang liên hệ đang được phát triển</h1>
</template>

<script>
export default {
name: "Contact"
}
</script>

<style scoped>

</style>
